// Translation: Account > Settings > Phone number (Arabic)
export default Object.freeze({
	form: {
		actions: {
			save: '',
			update: ''
		},
		fields: {
			phoneNumber: {
				promotion: {
					message: '',
					note: ''
				}
			}
		}
	},
	header: {
		title: ''
	}
})
